"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/web.dom.iterable");
var _job = require("@/api/job/job");
var _jobLog = require("@/api/job/jobLog");
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _elDragDialog = _interopRequireDefault(require("@/directive/el-drag-dialog"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _screenfull = _interopRequireDefault(require("screenfull"));
var _InstanceDetails = _interopRequireDefault(require("./components/InstanceDetails"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// waves directive
// base on element-ui
// secondary package based on el-pagination
var _default = exports.default = {
  name: "taskInstance",
  components: {
    Pagination: _Pagination.default,
    InstanceDetails: _InstanceDetails.default
  },
  directives: {
    waves: _waves.default,
    elDragDialog: _elDragDialog.default
  },
  data: function data() {
    return {
      tableKey: 0,
      labelPosition: "right",
      list: [],
      total: 0,
      listLoading: true,
      disabledStatus: false,
      listQuery: {
        index: 0,
        pageSize: 10,
        instanceId: undefined,
        wfInstanceId: undefined,
        status: "",
        jobId: undefined,
        type: "NORMAL"
      },
      logListQuery: {
        appId: 3,
        index: 0,
        instanceId: undefined
      },
      instanceDetailsVisible: false,
      currentInstanceId: undefined,
      instanceLogVisible: false,
      paginableInstanceLog: "",
      downloadLoading: false,
      columnHeaders: [{
        index: 0,
        title: "任务ID",
        isShow: true
      }, {
        index: 1,
        title: "任务名称",
        isShow: true
      }, {
        index: 2,
        title: "任务实例ID",
        isShow: true
      }, {
        index: 3,
        title: "状态",
        isShow: true
      }, {
        index: 4,
        title: "触发时间",
        isShow: true
      }, {
        index: 5,
        title: "结束时间",
        isShow: true
      }],
      initColumnCheckeds: ["任务ID", "任务名称", "任务实例ID", "状态", "触发时间", "结束时间"],
      columnCheckeds: ["任务ID", "任务名称", "任务实例ID", "任务状态", "触发时间", "结束时间"],
      checkAll: true,
      isIndeterminate: true,
      switchClass: "down",
      // 任务实例状态
      instanceStatusOptions: [{
        key: "WAITING_DISPATCH",
        label: "等待派发"
      }, {
        key: "WAITING_WORKER_RECEIVE",
        label: "等待Worker接收"
      }, {
        key: "RUNNING",
        label: "运行次数"
      }, {
        key: "FAILED",
        label: "失败"
      }, {
        key: "SUCCEED",
        label: "成功"
      }, {
        key: "CANCELED",
        label: "手动取消"
      }, {
        key: "STOPPED",
        label: "手动停止"
      }]
    };
  },
  watch: {
    columnCheckeds: function columnCheckeds(newArrayVal) {
      var _this = this;
      var nonSelecteds = this.columnHeaders.filter(function (item) {
        return newArrayVal.indexOf(item.title) === -1;
      }).map(function (item) {
        return item.title;
      });
      // 根据计算结果进行表格重绘
      this.columnHeaders.filter(function (item) {
        var isNonSelected = nonSelecteds.indexOf(item.title) !== -1;
        if (isNonSelected) {
          // 隐藏未选中的列
          item.isShow = false;
          _this.$nextTick(function () {
            _this.$refs.multipleTable.doLayout();
          });
        } else {
          // 显示已选中的列
          item.isShow = true;
          _this.$nextTick(function () {
            _this.$refs.multipleTable.doLayout();
          });
        }
      });
    }
  },
  created: function created() {
    if (window.innerWidth < 700) {
      this.labelPosition = "top";
    }
    this.getList();
  },
  methods: {
    instanceTableRowClassName: function instanceTableRowClassName(_ref) {
      var row = _ref.row;
      switch (row.status) {
        case 4:
          return "job-error-row";
        case 5:
          return "job-success-row";
        case 9:
        case 10:
          return "job-warning-row";
      }
    },
    getList: function getList(data) {
      var _this2 = this;
      this.listLoading = true;
      this.listQuery.appId = 3;
      if (data) {
        this.listQuery.index = data.page - 1;
        this.listQuery.pageSize = data.limit;
      }
      // 读取传递的参数（仅在首次加载或没有手动清除时）
      var jobId = this.$route.query.jobId;
      if (jobId !== undefined && jobId !== null && this.listQuery.jobId === undefined) {
        this.listQuery.jobId = jobId;
      }
      (0, _job.queryTaskInstance)(this.listQuery).then(function (response) {
        if (response.data.success === true) {
          _this2.list = response.data.data.data;
          _this2.total = response.data.data.totalItems;
          _this2.listQuery.index = response.data.data.index + 1;

          // 获取日志状态并匹配
          if (_this2.list && _this2.list.length > 0) {
            var instanceIds = _this2.list.map(function (item) {
              return item.instanceId;
            });
            (0, _jobLog.getJobLogEntityList)({
              instanceIds: instanceIds
            }).then(function (logResponse) {
              if (logResponse) {
                var logStatusMap = {};
                logResponse.forEach(function (log) {
                  logStatusMap[log.dataId] = log.logStatus === 1 ? 1 : 0;
                });

                // 将 logStatus 匹配到对应的 list 项
                _this2.list.forEach(function (item, index) {
                  if (logStatusMap[item.instanceId] !== undefined) {
                    _this2.$set(_this2.list, index, _objectSpread(_objectSpread({}, item), {}, {
                      logStatus: logStatusMap[item.instanceId]
                    }));
                  }
                });
              }
            });
          }
        } else {
          _this2.handleWarning(response.data.message);
        }
        _this2.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.index = 0;
      this.getList();
    },
    handleReset: function handleReset() {
      // 先重置查询条件
      this.listQuery.jobId = undefined;
      this.listQuery.instanceId = undefined;
      this.listQuery.status = undefined;
      // 再清除路由参数
      if (this.$route.query.jobId) {
        this.$router.replace({
          path: '/job/taskInstance'
        });
      }
      // 重新查询
      this.handleFilter();
    },
    handleFullscreen: function handleFullscreen() {
      var element = document.getElementById("screenfull-container");
      if (_screenfull.default.enabled) {
        _screenfull.default.request(element);
      }
      _screenfull.default.toggle();
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.columnCheckeds = val ? this.initColumnCheckeds : [];
      this.isIndeterminate = false;
    },
    handleCheckedChange: function handleCheckedChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.columnHeaders.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnHeaders.length;
    },
    fetchStatus: function fetchStatus(status) {
      return this.translateInstanceStatus(status);
    },
    translateInstanceStatus: function translateInstanceStatus(status) {
      switch (status) {
        case 1:
          return "等待派发";
        case 2:
          return "等待Worker接收";
        case 3:
          return "运行中";
        case 4:
          return "失败";
        case 5:
          return "成功";
        case 9:
          return "手动取消";
        case 10:
          return "手动停止";
        default:
          return "UNKNOWN";
      }
    },
    handleDetails: function handleDetails() {
      if (!this.handleValidate()) {
        return;
      }
      this.instanceDetailsVisible = true;
      this.currentInstanceId = this.multipleSelection[0].instanceId;
    },
    handleDetailsRow: function handleDetailsRow(row) {
      this.instanceDetailsVisible = true;
      this.currentInstanceId = row.instanceId;
    },
    handleLog: function handleLog() {
      var _this3 = this;
      if (!this.handleValidate()) {
        return;
      }
      this.logListQuery.instanceId = this.multipleSelection[0].instanceId;
      (0, _job.queryInstanceLog)(this.logListQuery).then(function (response) {
        _this3.paginableInstanceLog = response.data.data.data;
        _this3.instanceLogVisible = true;
      });
    },
    handleLogRow: function handleLogRow(row) {
      this.$router.push({
        path: '/job/jobLog',
        query: {
          dataId: row.instanceId
        }
      });
    },
    downloadLog: function downloadLog() {
      this.logListQuery.instanceId = this.multipleSelection[0].instanceId;
      (0, _job.downloadInstanceLog)(this.logListQuery).then(function (response) {
        window.open(response.data.data);
      });
    },
    handleRetry: function handleRetry() {
      var _this4 = this;
      if (!this.handleValidate()) {
        return;
      }
      this.logListQuery.instanceId = this.multipleSelection[0].instanceId;
      (0, _job.retryInstance)(this.logListQuery).then(function (response) {
        if (response.data.success === true) {
          _this4.$message({
            message: "重试成功",
            type: "success",
            duration: 2000
          });
          _this4.handleReset();
        } else {
          _this4.handleWarning(response.data.message);
        }
      });
    },
    handleRetryRow: function handleRetryRow(row) {
      var _this5 = this;
      this.$confirm('确定要重试此任务实例吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this5.logListQuery.instanceId = row.instanceId;
        (0, _job.retryInstance)(_this5.logListQuery).then(function (response) {
          if (response.data.success === true) {
            _this5.$message({
              message: "重试成功",
              type: "success",
              duration: 2000
            });
            _this5.handleReset();
          } else {
            _this5.handleWarning(response.data.message);
          }
        });
      }).catch(function () {
        // 用户取消
      });
    },
    handleStop: function handleStop() {
      var _this6 = this;
      if (!this.handleValidate()) {
        return;
      }
      this.logListQuery.instanceId = this.multipleSelection[0].instanceId;
      (0, _job.stopInstance)(this.logListQuery).then(function (response) {
        if (response.data.success === true) {
          _this6.$message({
            message: "停止成功",
            type: "success",
            duration: 2000
          });
          _this6.handleReset();
        } else {
          _this6.handleWarning(response.data.message);
        }
      });
    },
    handleStopRow: function handleStopRow(row) {
      var _this7 = this;
      this.$confirm('确定要停止此任务实例吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this7.logListQuery.instanceId = row.instanceId;
        (0, _job.stopInstance)(_this7.logListQuery).then(function (response) {
          if (response.data.success === true) {
            _this7.$message({
              message: "停止成功",
              type: "success",
              duration: 2000
            });
            _this7.handleReset();
          } else {
            _this7.handleWarning(response.data.message);
          }
        });
      }).catch(function () {
        // 用户取消
      });
    },
    handleValidate: function handleValidate() {
      return true;
    },
    handleWarning: function handleWarning(response) {
      this.$message({
        message: response,
        type: "warning",
        duration: 2000
      });
      this.disabledStatus = false;
    }
  }
};